import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCategoryListResponseBody,
  IApiCreateCategoryRequestBody,
  IApiCreateCategoryResponseBody,
  IApiDeleteCategoryResponseBody,
  IApiGetCategoryListRequestBody,
  IApiGetCategoryResponseBody,
  IApiUpdateCategoryOrderRequestBody,
  IApiUpdateCategoryOrderResponseBody,
  IApiUpdateCategoryRequestBody,
  IApiUpdateCategoryResponseBody,
} from './CategoriesApi.types';

export class CategoriesApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    body?: IApiGetCategoryListRequestBody,
  ): Promise<IApiCategoryListResponseBody> {
    const request: IApiJsonRequest<IApiGetCategoryListRequestBody> = {
      method: 'get',
      path: '/admin/press/categories',
      params: body,
    };

    const response = await this.client.fetchJson<IApiCategoryListResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async get(
    appId: string,
    categoryId: string,
  ): Promise<IApiGetCategoryResponseBody> {
    const request: IApiJsonRequest = {
      method: 'get',
      path: `/press/categories/${categoryId}`,
    };

    const response = await this.client.fetchJson<IApiGetCategoryResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async create(
    appId: string,
    body: IApiCreateCategoryRequestBody,
  ): Promise<IApiCreateCategoryResponseBody> {
    const request: IApiJsonRequest = {
      method: 'post',
      path: `/press/categories`,
      body,
    };

    const response =
      await this.client.fetchJson<IApiCreateCategoryResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async update(
    appId: string,
    categoryId: string,
    body: IApiUpdateCategoryRequestBody,
  ): Promise<IApiUpdateCategoryResponseBody> {
    const request: IApiJsonRequest = {
      method: 'put',
      path: `/press/categories/${categoryId}`,
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateCategoryResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async delete(
    appId: string,
    categoryId: string,
  ): Promise<IApiDeleteCategoryResponseBody> {
    const request: IApiJsonRequest = {
      method: 'delete',
      path: `/press/categories/${categoryId}`,
    };

    const response =
      await this.client.fetchJson<IApiDeleteCategoryResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async updateOrder(
    appId: string,
    categoryId: string,
    body: IApiUpdateCategoryOrderRequestBody,
  ): Promise<IApiUpdateCategoryOrderResponseBody> {
    const request: IApiJsonRequest = {
      method: 'put',
      path: `/press/categories/${categoryId}/order`,
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateCategoryOrderResponseBody>(
        request,
        { appId },
      );

    return response.body;
  }
}
